import React, { useRef, useEffect, useState } from "react";
import { Button, Layout, Menu, notification, theme } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  UserOutlined,
  DashboardOutlined,
  BankOutlined,
  DatabaseOutlined,
  IdcardOutlined,
  SettingOutlined,
  ClearOutlined,
  RadarChartOutlined,
  ScanOutlined,
  FolderOpenFilled,
  FolderOutlined,
  LockOutlined,
} from "@ant-design/icons";

function Sidebar() {
  let navigate = useNavigate();
  const { Sider } = Layout;
  const { useToken } = theme;
  const { token } = useToken();
  const [openKeys, setOpenKeys] = useState([]);
  const location = useLocation();
  const breadcrumbUrls = location.pathname.split("/").filter(Boolean);
  const lastBreadcrumbUrl = breadcrumbUrls[breadcrumbUrls.length - 1];
  const [selectedMenuItem, setSelectedMenuItem] = useState();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const dataFetchedRef = useRef(false);
  const isUserRole = decodedToken?.roles.includes("SYSTEM_USER");
  const isSUPERADMIN = decodedToken?.roles.includes("SUPER_ADMIN");
  const isSUPERTenantADMIN = decodedToken?.roles.includes("TENANT_ADMIN");
  console.log(token.environment);
  const isSubtenantADMIN = decodedToken?.roles.includes("SUB_TENANT_ADMIN");
  const isSubtenantUser = decodedToken?.roles.includes("SUB_TENANT_USER");
  const isLoginCodeUsed = localStorage.getItem("loginCodeUsed") === "true";

  const switched = localStorage.getItem("switched") === "true";

  const privilagesAccess = () => {
    notification.open({
      message: <span style={{ fontWeight: "bold" }}>Error</span>,
      description:
        "You are not authorised to access this page. Please contact you admin.",
      closeIcon: false,
      duration: 3,
      style: {
        backgroundColor: "#ffb3b3",
        color: "red",
      },
    });
  };

  const [roleCode, setRoleCode] = useState("");
  useEffect(() => {
    const userDetailsString = localStorage.getItem("decodedToken");
    if (userDetailsString) {
      const userDetails = JSON.parse(userDetailsString);
      const firstRoleDTO = userDetails.roles && userDetails.roles[0];
      if (firstRoleDTO) {
        setRoleCode(firstRoleDTO);
      }
    }
  }, []);
  useEffect(() => {
    if (lastBreadcrumbUrl === "dashboard") {
      setSelectedMenuItem("1");
    } else if (
      [
        "settings",
        "set-permissions",
        "time-configurations",
        "currency-configurations",
        "sensor-configurations",
        "twilio-configurations",
        "edit-configurations",
        "add-twilio-configurations",
      ].includes(lastBreadcrumbUrl)
    ) {
      setSelectedMenuItem("6");
    } else if (
      ["complaints", "create-complaint", "complaint-reply"].includes(
        lastBreadcrumbUrl
      )
    ) {
      setSelectedMenuItem("12");
    } else if (
      ["suppliers", "add-Supplier", "edit-Supplier"].includes(lastBreadcrumbUrl)
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("13");
    } else if (lastBreadcrumbUrl === "sub-tenants") {
      setSelectedMenuItem("25");
    } else if (lastBreadcrumbUrl === "tenants") {
      setSelectedMenuItem("2");
    } else if (
      ["sensor", "add-sensor", "edit-sensor"].includes(lastBreadcrumbUrl)
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("29");
    } else if (
      ["storage-sensor", "add-storage-sensor", "edit-storage-sensor"].includes(
        lastBreadcrumbUrl
      )
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("30");
    } else if (
      [
        "storage-instructions",
        "add-storage-instructions",
        "edit-storage-instructions",
      ].includes(lastBreadcrumbUrl)
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("31");
    } else if (
      ["allergens", "add-allergens", "edit-allergens"].includes(
        lastBreadcrumbUrl
      )
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("14");
    } else if (
      ["shelf-life", "add-shelf-life", "edit-shelf-life"].includes(
        lastBreadcrumbUrl
      )
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("15");
    } else if (
      ["Cooling-Shelf", "add-Cooling-Shelf", "edit-Cooling-Shelf"].includes(
        lastBreadcrumbUrl
      )
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("17");
    } else if (
      [
        "storage-suggestions",
        "add-storage-suggestions",
        "edit-storage-suggestions",
      ].includes(lastBreadcrumbUrl)
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("16");
    } else if (["fridge-temperature-report"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("33");
    } else if (["waste-reports"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("28");
    } else if (["inventory-reports"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("27");
    } else if (["raw-waste-reports"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("35");
    } else if (["cleaning-traceability"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("36");
    } else if (["stock-adjustment"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("37");
    } else if (["aftercook"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("38");
    } else if (["cold-traceability"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("39");
    } else if (["hot-hold"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("40");
    }else if (["cooling-process"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("41");
    }else if (["reheat-process"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["Reports"]);
      setSelectedMenuItem("42");
    }
    else if (
      ["storage", "live-storage", "add-storage", "edit-storage"].includes(
        lastBreadcrumbUrl
      )
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("26");
    } else if (
      ["ingredients", "add-ingredients", "edit-ingredients"].includes(
        lastBreadcrumbUrl
      )
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("20");
    } else if (
      ["MCQ-management", "view-MCQ", "add-MCQ", "edit-MCQ"].includes(
        lastBreadcrumbUrl
      )
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("7");
    } else if (
      [
        "designations",
        "add-designation",
        "edit-designation",
        "hierarchy-table",
      ].includes(lastBreadcrumbUrl)
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("11");
    } else if (
      ["recipe", "add-recipe", "edit-recipe"].includes(lastBreadcrumbUrl)
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("18");
    } else if (["stock"].includes(lastBreadcrumbUrl)) {
      setSelectedMenuItem("19");
    } else if (["actions", "add-actions"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("8");
    } else if (
      ["departments", "add-department", "edit-department"].includes(
        lastBreadcrumbUrl
      )
    ) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("10");
    } else if (
      lastBreadcrumbUrl === "users" ||
      lastBreadcrumbUrl === "health" ||
      lastBreadcrumbUrl === "user-role" ||
      lastBreadcrumbUrl === "add-users" ||
      lastBreadcrumbUrl === "invite-sub-tenants-users" ||
      lastBreadcrumbUrl === "invite-users"
    ) {
      setSelectedMenuItem("3");
    } else if (lastBreadcrumbUrl === "daily-cleaning-traceability") {
      setOpenKeys(["Cleaning"]);
      setSelectedMenuItem("22");
    } else if (lastBreadcrumbUrl === "sensor-dashboard") {
      setSelectedMenuItem("32");
    } else if (lastBreadcrumbUrl === "weekly-cleaning-traceability") {
      setOpenKeys(["Cleaning"]);
      setSelectedMenuItem("23");
    } else if (lastBreadcrumbUrl === "monthly-cleaning-traceability") {
      setOpenKeys(["Cleaning"]);
      setSelectedMenuItem("24");
    } else if (["components", "add-components"].includes(lastBreadcrumbUrl)) {
      setOpenKeys(["subMenu"]);
      setSelectedMenuItem("9");
    } else if (
      [
        "cleaning-list",
        "add-cleaning-traceability-item",
        "edit-cleaning-traceability-item",
      ].includes(lastBreadcrumbUrl)
    ) {
      setOpenKeys(["Cleaning"]);
      setSelectedMenuItem("21");
    } else if (["onboarded-users"].includes(lastBreadcrumbUrl)) {
      setSelectedMenuItem("4");
    } else if (["user-logs"].includes(lastBreadcrumbUrl)) {
      setSelectedMenuItem("7");
    }

    if (
      [
        "users",
        "invite-users",
        "health",
        "create-role",
        "designations",
        "add-designation",
        "edit-designation",
        "hierarchy-table",
        "departments",
        "add-department",
        "edit-department",
      ].includes(lastBreadcrumbUrl)
    ) {
      if (isUser === "true") {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        privilagesAccess();
        return navigate("/dashboard");
      }
    }
  }, [setSelectedMenuItem, lastBreadcrumbUrl]);
  const checkPermissionAndNavigate = (authority, path) => {
    if (
      !decodedToken?.permissions?.some(
        (permission) => permission?.authority === authority
      )
    ) {
      if (dataFetchedRef.current) return;
      dataFetchedRef.current = true;
      privilagesAccess();
      navigate("/dashboard");
    }
  };
  const isSUPER_ADMIN = localStorage.getItem("isSUPER_ADMIN");
  const isADMIN = localStorage.getItem("isADMIN");
  const isUser = localStorage.getItem("isUser");
  const handleMenuClick = (menuItem) => {
    setSelectedMenuItem(menuItem.key);
  };

  const handleSubMenuOpenChange = (keys) => {
    setOpenKeys(keys);
  };
  return (
    <>
      {(!isUserRole && !isLoginCodeUsed) && <Sider width={230} theme="light" className="SidebarClass">
        <div
          className="admin-logo"
          style={{
            backgroundColor: token.colorPrimary,
          }}
        >
          <img
            src="/assest/Images/Logo/admin-logo.png"
            className="logo-png"
            style={{ width: "100%" }}
          />
        </div>
        <Menu
          theme="dark"
          style={{
            height: "auto",
            paddingLeft: "7px",
            paddingRight: "7px",
            backgroundColor: token.colorPrimary,
          }}
          mode="inline"
          selectedKeys={[selectedMenuItem]}
          onClick={handleMenuClick}
          openKeys={openKeys}
          onOpenChange={handleSubMenuOpenChange}
        >
          <Menu.Item key="1" icon={<DashboardOutlined />}>
            <Link to={"/dashboard"}>Dashboard</Link>
          </Menu.Item>

          {/* {isSUPER_ADMIN === "true" && ( */}
          <>
            <Menu.Item
              key="2"
              icon={<BankOutlined />}
              className={
                decodedToken?.permissions?.some(
                  (permission) => permission?.authority === "VIEW_TENANT"
                ) && decodedToken.roles[0] === "SUPER_ADMIN"
                  ? ""
                  : "d-none"
              }
            >
              <Link to={"/tenants"}>Customers</Link>
            </Menu.Item>
            <Menu.Item
              key="25"
              icon={<BankOutlined />}
              className={
                // decodedToken?.permissions?.some(
                //   (permission) => permission?.authority === "VIEW_SUB_TENANT" && (decodedToken.roles[0] === "SUPER_ADMIN" || decodedToken.roles[0] === "TENANT_ADMIN") && !switched
                // )
                isSUPERTenantADMIN && !switched
                  ? ""
                  : "d-none"
              }
            >
              <Link to={"/sub-tenants"}>Shop / Store</Link>
            </Menu.Item>
            {/* <Menu.Item
              key="25"
              icon={<BankOutlined />}
              className={
                decodedToken?.permissions?.some(
                  (permission) => permission?.authority === "VIEW_SUB_TENANT" && !switched
                )
                  ? ""
                  : "d-none"
              }
            >
              <Link to={"/sub-tenants"}>Shop / Store</Link>
            </Menu.Item> */}
            <Menu.Item
              key="3"
              icon={<UserOutlined />}
              className={
                decodedToken?.permissions?.some(
                  (permission) => permission?.authority === "VIEW_USER"
                )
                  ? ""
                  : "d-none"
              }
            >
              <Link to={"/users"}>My Store Users</Link>
            </Menu.Item>
            <Menu.Item
              key="4"
              icon={<UserOutlined />}
              className={
                decodedToken?.permissions?.some(
                  (permission) => permission?.authority === "VIEW_USER"
                )
                  ? ""
                  : "d-none"
              }
            >
              <Link to={"/onboarded-users"}>Onboarded Users</Link>
            </Menu.Item>
            <Menu.SubMenu
              key="subMenu"
              className={
                decodedToken.roles[0] === "TENANT_ADMIN" || decodedToken.roles[0] === "SUPER_ADMIN" || decodedToken.roles[0] === "SUB_TENANT_ADMIN"
                  ? ""
                  : "d-none"
              }
              icon={<DatabaseOutlined />}
              title="Masters"
            >
              <Menu.Item
                key="7"
                className={
                  decodedToken.roles[0] === "SUPER_ADMIN"
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/MCQ-management"}>MCQ Management </Link>
              </Menu.Item>
              {/* <Menu.Item
                key="8"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_ACTION"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/actions"}>Actions </Link>
              </Menu.Item> */}
              {/* <Menu.Item
                key="9"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_COMPONENT"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/components"}>Components</Link>
              </Menu.Item> */}
              <Menu.Item
                key="11"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_DESIGNATION"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/designations"}>Designations</Link>
              </Menu.Item>
              <Menu.Item
                key="10"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_INSTITUTION"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/departments"}>Departments</Link>
              </Menu.Item>
              <Menu.Item
                key="14"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_ALLERGENS"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/allergens"}>Allergens</Link>
              </Menu.Item>
              <Menu.Item
                key="15"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_SHELF_LIFE"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/shelf-life"}>Shelf Life</Link>
              </Menu.Item>
              <Menu.Item
                key="17"
                className={
                  decodedToken?.permissions?.some(
                    (permission) =>
                      permission?.authority === "VIEW_COOLING_SHELF_LIFE"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/Cooling-Shelf"}>Cooling Shelf</Link>
              </Menu.Item>
              <Menu.Item
                key="18"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_RECIPE"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/recipe"}>Recipe</Link>
              </Menu.Item>
              {/* <Menu.Item
                key="20"
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'VIEW_INGREDIENTS'
                ) ? '' : 'd-none'}
              >
                <Link to={"/masters/ingredients"}>Ingredients</Link>
              </Menu.Item> */}
              <Menu.Item
                key="29"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_SENSOR"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/sensor"}>Sensor</Link>
              </Menu.Item>
              <Menu.Item
                key="26"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_STORAGE"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/storage"}>Storage</Link>
              </Menu.Item>

              {/* <Menu.Item
                key="30"
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'VIEW_SENSOR'
                ) ? '' : 'd-none'}
              >
                <Link to={"/masters/storage-sensor"}>Storage Sensor</Link>
              </Menu.Item> */}

              <Menu.Item
                key="16"
                className={
                  decodedToken?.permissions?.some(
                    (permission) =>
                      permission?.authority === "VIEW_STORAGE_SUGGESTION"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/storage-suggestions"}>
                  Storage Suggestions
                </Link>
              </Menu.Item>
              <Menu.Item
                key="31"
                className={
                  decodedToken?.permissions?.some(
                    (permission) =>
                      permission?.authority === "VIEW_STORAGE_INSTRUCTIONS"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/storage-instructions"}>
                  Storage Instructions
                </Link>
              </Menu.Item>
              <Menu.Item
                key="13"
                className={
                  decodedToken?.permissions?.some(
                    (permission) => permission?.authority === "VIEW_SUPPLIER"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/masters/suppliers"}>Suppliers</Link>
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.SubMenu
              key="Cleaning"
              className={
                decodedToken?.permissions?.some(
                  (permission) =>
                    permission?.authority === "VIEW_CLEANING_TRACEABILITY_ITEM"
                )
                  ? ""
                  : "d-none"
              }
              icon={<ClearOutlined />}
              title="Task Builder"
            >
              {/* <Menu.Item
                key="21"
                className={
                  decodedToken?.permissions?.some(
                    (permission) =>
                      permission?.authority ===
                      "VIEW_CLEANING_TRACEABILITY_ITEM"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/cleaning-traceability/cleaning-list"}>
                  Cleaning List
                </Link>
              </Menu.Item> */}
              <Menu.Item
                key="25"
                className={
                  decodedToken?.permissions?.some(
                    (permission) =>
                      permission?.authority ===
                      "VIEW_CLEANING_TRACEABILITY_DAILY"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/cleaning-traceability/cleaning-areas"}>
                  Task Areas
                </Link>
              </Menu.Item>
              <Menu.Item
                key="22"
                className={
                  decodedToken?.permissions?.some(
                    (permission) =>
                      permission?.authority ===
                      "VIEW_CLEANING_TRACEABILITY_DAILY"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/daily-cleaning-traceability"}>Daily Tasks</Link>
              </Menu.Item>
              <Menu.Item
                key="23"
                className={
                  decodedToken?.permissions?.some(
                    (permission) =>
                      permission?.authority ===
                      "VIEW_CLEANING_TRACEABILITY_WEEKLY"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/weekly-cleaning-traceability"}>Weekly Tasks</Link>
              </Menu.Item>

              <Menu.Item
                key="24"
                className={
                  decodedToken?.permissions?.some(
                    (permission) =>
                      permission?.authority ===
                      "VIEW_CLEANING_TRACEABILITY_MONTHLY"
                  )
                    ? ""
                    : "d-none"
                }
              >
                <Link to={"/monthly-cleaning-traceability"}>Monthly Tasks</Link>
              </Menu.Item>
            </Menu.SubMenu>
            <Menu.Item
              key="12"
              icon={<IdcardOutlined />}
              className={
                decodedToken?.permissions?.some(
                  (permission) => permission?.authority === "VIEW_COMPLIANT"
                )
                  ? ""
                  : "d-none"
              }
            >
              <Link to={"/complaints"}>Corrective Action / Maintenance</Link>
            </Menu.Item>
            <Menu.Item
              key="32"
              className={isSUPERADMIN || isSUPERTenantADMIN ? "" : "d-none"}
              icon={<ScanOutlined />}
            >
              <Link to={"/sensor-dashboard"}>Sensor Dashboard</Link>
            </Menu.Item>
            <Menu.SubMenu
              key="Reports"
              icon={<FolderOutlined />}
              title="Reports"
              className={isSUPERADMIN || isSUPERTenantADMIN || isSubtenantADMIN ? "" : "d-none"}
            >
              <Menu.Item key="27">
                <Link to={"/reports/inventory-reports"}>Inventory Report</Link>
              </Menu.Item>
              <Menu.Item key="28">
                <Link to={"/reports/waste-reports"}>Waste Report</Link>
              </Menu.Item>
              <Menu.Item key="33">
                <Link to={"/reports/fridge-temperature-report"}>
                  Fridge Temperature
                </Link>
              </Menu.Item>

              <Menu.Item key="35">
                <Link to={"/reports/raw-waste-reports"}>
                  Raw Waste Report
                </Link>
              </Menu.Item>
              <Menu.Item key="36">
                <Link to={"/reports/cleaning-traceability"}>
                  All Tasks Report
                </Link>
              </Menu.Item>
              <Menu.Item key="37">
                <Link to={"/reports/stock-adjustment"}>
                  Stock Adjustment
                </Link>
              </Menu.Item>
              <Menu.Item key="38">
                <Link to={"/reports/aftercook"}>
                  Aftercook
                </Link>
              </Menu.Item>
              <Menu.Item key="39">
                <Link to={"/reports/cold-traceability"}>
                  Cold Traceability
                </Link>
              </Menu.Item>
              <Menu.Item key="40">
                <Link to={"/reports/hot-hold"}>
                  Hot Hold
                </Link>
              </Menu.Item>
              <Menu.Item key="41">
                <Link to={"/reports/cooling-process"}>
                  Cooling Process
                </Link>
              </Menu.Item>
              <Menu.Item key="42">
                <Link to={"/reports/reheat-process"}>
                  Reheat Process
                </Link>
              </Menu.Item>
            </Menu.SubMenu>
          </>

          {/* {isADMIN === "true" && isSUPER_ADMIN === "false" && (
            <>
              <Menu.Item
                key="3"
                icon={<UserOutlined />}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'VIEW_USER'
                ) ? '' : 'd-none'}
              >
                <Link to={"/users"}>Users</Link>
              </Menu.Item>
              <Menu.Item
                key="25"
                icon={<BankOutlined />}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'VIEW_SUB_TENANT'
                ) ? '' : 'd-none'}
              >
                <Link to={"/sub-tenants"}>Sub Tenants</Link>
              </Menu.Item>
              <Menu.SubMenu
                key="subMenu"
                icon={<DatabaseOutlined />}
                title="Masters"
              >
                <Menu.Item
                  key="11"
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'VIEW_DESIGNATION'
                  ) ? '' : 'd-none'}
                >
                  <Link to={"/masters/designations"}>Designations</Link>
                </Menu.Item>
                <Menu.Item
                  key="10"
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'VIEW_INSTITUTION'
                  ) ? '' : 'd-none'}
                >
                  <Link to={"/masters/departments"}>Departments</Link>
                </Menu.Item>

                <Menu.Item
                  key="14"
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'VIEW_ALLERGENS'
                  ) ? '' : 'd-none'}
                >
                  <Link to={"/masters/allergens"}>Allergens</Link>
                </Menu.Item>
                <Menu.Item
                  key="13"
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'VIEW_SUPPLIER'
                  ) ? '' : 'd-none'}
                >
                  <Link to={"/masters/suppliers"}>Suppliers</Link>
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.Item
                key="12"
                icon={<IdcardOutlined />}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'VIEW_COMPLIANT'
                ) ? '' : 'd-none'}
              >
                <Link to={"/complaints"}>Complaints</Link>
              </Menu.Item>
            </>
          )} */}
          {/* <Menu.Item
            key="7"
            className={isSubtenantADMIN || isSubtenantUser ? "d-none" : ""}
            icon={<LockOutlined />}
          >
            <Link to={"/user-logs"}>User Logs</Link>
          </Menu.Item> */}
          <Menu.Item
            key="6"
            className={isSubtenantADMIN || isSubtenantUser ? "d-none" : ""}
            icon={<SettingOutlined />}
          >
            <Link to={"/settings"}>Settings</Link>
          </Menu.Item>
      
          <br />
          {/* {switched && <Menu.Item
          >
            <Button color="default" variant="solid" style={{ width: "100%" }} onClick={() => {
              
            }}>
              Switch Back
            </Button>
          </Menu.Item>} */}
          <Menu.Item
          >
            <Button color="blue" variant="solid" style={{ width: "100%" }} onClick={() => {
              localStorage.clear();
              sessionStorage.clear();
              navigate("/");
              window.location.reload(true);
            }}>
              Clear Cache
            </Button>
          </Menu.Item>
        </Menu>


      </Sider>}
    </>
  );
}

export default Sidebar;
